import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/atoms/Badge';
import SegmentedControl from '@/components/molecules/SegmentedControl';

export type LiceReportMode = 'weekly' | 'daily';

export interface LiceReportModeToggleProps {
    mode: LiceReportMode;
    onModeChange: (mode: LiceReportMode) => void;
}

/**
 * Weekly against by-day, and nothing else.
 *
 * Sits beside the page title, where it belongs: it chooses which report the page is showing.
 * The controls that narrow *within* a mode — the week pills, the date pickers, the data
 * source — used to sit up here too, which put a wrapping row of week pills level with the
 * heading. They live in {@link LiceReportFilters}, inside the page body.
 */
export default function LiceReportModeToggle({ mode, onModeChange }: LiceReportModeToggleProps) {
    const { t } = useTranslation('liceReport');

    return (
        <SegmentedControl<LiceReportMode>
            value={mode}
            onChange={(nextMode) => onModeChange(nextMode)}
            options={[
                { value: 'weekly', label: t('filters.weekly') },
                {
                    value: 'daily',
                    label: (
                        <>
                            {t('filters.byDay')}{' '}
                            <Badge tone="success" variant="solid" size="xs">
                                {t('filters.badge')}
                            </Badge>
                        </>
                    ),
                },
            ]}
        />
    );
}
